const dialCodes = [
  {
    name: 'Afghanistan',
    code: '93',
    isoCode2digits: 'AF',
    isoCode3digits: 'AFG',
  },
  {
    name: 'Albania',
    code: '355',
    isoCode2digits: 'AL',
    isoCode3digits: 'ALB',
  },
  {
    name: 'Algeria',
    code: '213',
    isoCode2digits: 'DZ',
    isoCode3digits: 'DZA',
  },
  {
    name: 'American Samoa',
    code: '1',
    isoCode2digits: 'AS',
    isoCode3digits: 'ASM',
  },
  {
    name: 'Andorra',
    code: '376',
    isoCode2digits: 'AD',
    isoCode3digits: 'AND',
  },
  {
    name: 'Angola',
    code: '244',
    isoCode2digits: 'AO',
    isoCode3digits: 'AGO',
  },
  {
    name: 'Anguilla',
    code: '1',
    isoCode2digits: 'AI',
    isoCode3digits: 'AIA',
  },
  {
    name: 'Antarctica',
    code: '672',
    isoCode2digits: 'AQ',
    isoCode3digits: 'ATA',
  },
  {
    name: 'Antigua and Barbuda',
    code: '1',
    isoCode2digits: 'AG',
    isoCode3digits: 'ATG',
  },
  {
    name: 'Argentina',
    code: '54',
    isoCode2digits: 'AR',
    isoCode3digits: 'ARG',
  },
  {
    name: 'Armenia',
    code: '374',
    isoCode2digits: 'AM',
    isoCode3digits: 'ARM',
  },
  {
    name: 'Aruba',
    code: '297',
    isoCode2digits: 'AW',
    isoCode3digits: 'ABW',
  },
  {
    name: 'Australia',
    code: '61',
    isoCode2digits: 'AU',
    isoCode3digits: 'AUS',
  },
  {
    name: 'Austria',
    code: '43',
    isoCode2digits: 'AT',
    isoCode3digits: 'AUT',
  },
  {
    name: 'Azerbaijan',
    code: '994',
    isoCode2digits: 'AZ',
    isoCode3digits: 'AZE',
  },
  {
    name: 'Bahamas',
    code: '1',
    isoCode2digits: 'BS',
    isoCode3digits: 'BHS',
  },
  {
    name: 'Bahrain',
    code: '973',
    isoCode2digits: 'BH',
    isoCode3digits: 'BHR',
  },
  {
    name: 'Bangladesh',
    code: '880',
    isoCode2digits: 'BD',
    isoCode3digits: 'BGD',
  },
  {
    name: 'Barbados',
    code: '1',
    isoCode2digits: 'BB',
    isoCode3digits: 'BRB',
  },
  {
    name: 'Belarus',
    code: '375',
    isoCode2digits: 'BY',
    isoCode3digits: 'BLR',
  },
  {
    name: 'Belgium',
    code: '32',
    isoCode2digits: 'BE',
    isoCode3digits: 'BEL',
  },
  {
    name: 'Belize',
    code: '501',
    isoCode2digits: 'BZ',
    isoCode3digits: 'BLZ',
  },
  {
    name: 'Benin',
    code: '229',
    isoCode2digits: 'BJ',
    isoCode3digits: 'BEN',
  },
  {
    name: 'Bermuda',
    code: '1',
    isoCode2digits: 'BM',
    isoCode3digits: 'BMU',
  },
  {
    name: 'Bhutan',
    code: '975',
    isoCode2digits: 'BT',
    isoCode3digits: 'BTN',
  },
  {
    name: 'Bolivia',
    code: '591',
    isoCode2digits: 'BO',
    isoCode3digits: 'BOL',
  },
  {
    name: 'Bosnia and Herzegovina',
    code: '387',
    isoCode2digits: 'BA',
    isoCode3digits: 'BIH',
  },
  {
    name: 'Botswana',
    code: '267',
    isoCode2digits: 'BW',
    isoCode3digits: 'BWA',
  },
  {
    name: 'Brazil',
    code: '55',
    isoCode2digits: 'BR',
    isoCode3digits: 'BRA',
  },
  {
    name: 'British Indian Ocean Territory',
    code: '246',
    isoCode2digits: 'IO',
    isoCode3digits: 'IOT',
  },
  {
    name: 'British Virgin Islands',
    code: '1',
    isoCode2digits: 'VG',
    isoCode3digits: 'VGB',
  },
  {
    name: 'Brunei',
    code: '673',
    isoCode2digits: 'BN',
    isoCode3digits: 'BRN',
  },
  {
    name: 'Bulgaria',
    code: '359',
    isoCode2digits: 'BG',
    isoCode3digits: 'BGR',
  },
  {
    name: 'Burkina Faso',
    code: '226',
    isoCode2digits: 'BF',
    isoCode3digits: 'BFA',
  },
  {
    name: 'Myanmar',
    code: '95',
    isoCode2digits: 'MM',
    isoCode3digits: 'MMR',
  },
  {
    name: 'Burundi',
    code: '257',
    isoCode2digits: 'BI',
    isoCode3digits: 'BDI',
  },
  {
    name: 'Cambodia',
    code: '855',
    isoCode2digits: 'KH',
    isoCode3digits: 'KHM',
  },
  {
    name: 'Cameroon',
    code: '237',
    isoCode2digits: 'CM',
    isoCode3digits: 'CMR',
  },
  {
    name: 'Canada',
    code: '1',
    isoCode2digits: 'CA',
    isoCode3digits: 'CAN',
  },
  {
    name: 'Cape Verde',
    code: '238',
    isoCode2digits: 'CV',
    isoCode3digits: 'CPV',
  },
  {
    name: 'Cayman Islands',
    code: '1',
    isoCode2digits: 'KY',
    isoCode3digits: 'CYM',
  },
  {
    name: 'Central African Republic',
    code: '236',
    isoCode2digits: 'CF',
    isoCode3digits: 'CAF',
  },
  {
    name: 'Chad',
    code: '235',
    isoCode2digits: 'TD',
    isoCode3digits: 'TCD',
  },
  {
    name: 'Chile',
    code: '56',
    isoCode2digits: 'CL',
    isoCode3digits: 'CHL',
  },
  {
    name: 'China',
    code: '86',
    isoCode2digits: 'CN',
    isoCode3digits: 'CHN',
  },
  {
    name: 'Christmas Island',
    code: '61',
    isoCode2digits: 'CX',
    isoCode3digits: 'CXR',
  },
  {
    name: 'Cocos Islands',
    code: '61',
    isoCode2digits: 'CC',
    isoCode3digits: 'CCK',
  },
  {
    name: 'Colombia',
    code: '57',
    isoCode2digits: 'CO',
    isoCode3digits: 'COL',
  },
  {
    name: 'Comoros',
    code: '269',
    isoCode2digits: 'KM',
    isoCode3digits: 'COM',
  },
  {
    name: 'Republic of the Congo',
    code: '242',
    isoCode2digits: 'CG',
    isoCode3digits: 'COG',
  },
  {
    name: 'Democratic Republic of the Congo',
    code: '243',
    isoCode2digits: 'CD',
    isoCode3digits: 'COD',
  },
  {
    name: 'Cook Islands',
    code: '682',
    isoCode2digits: 'CK',
    isoCode3digits: 'COK',
  },
  {
    name: 'Costa Rica',
    code: '506',
    isoCode2digits: 'CR',
    isoCode3digits: 'CRI',
  },
  {
    name: 'Croatia',
    code: '385',
    isoCode2digits: 'HR',
    isoCode3digits: 'HRV',
  },
  {
    name: 'Cuba',
    code: '53',
    isoCode2digits: 'CU',
    isoCode3digits: 'CUB',
  },
  {
    name: 'Curacao',
    code: '599',
    isoCode2digits: 'CW',
    isoCode3digits: 'CUW',
  },
  {
    name: 'Cyprus',
    code: '357',
    isoCode2digits: 'CY',
    isoCode3digits: 'CYP',
  },
  {
    name: 'Czech Republic',
    code: '420',
    isoCode2digits: 'CZ',
    isoCode3digits: 'CZE',
  },
  {
    name: 'Denmark',
    code: '45',
    isoCode2digits: 'DK',
    isoCode3digits: 'DNK',
  },
  {
    name: 'Djibouti',
    code: '253',
    isoCode2digits: 'DJ',
    isoCode3digits: 'DJI',
  },
  {
    name: 'Dominica',
    code: '1',
    isoCode2digits: 'DM',
    isoCode3digits: 'DMA',
  },
  {
    name: 'Dominican Republic',
    code: '1',
    isoCode2digits: 'DO',
    isoCode3digits: 'DOM',
  },
  {
    name: 'East Timor',
    code: '670',
    isoCode2digits: 'TL',
    isoCode3digits: 'TLS',
  },
  {
    name: 'Ecuador',
    code: '593',
    isoCode2digits: 'EC',
    isoCode3digits: 'ECU',
  },
  {
    name: 'Egypt',
    code: '20',
    isoCode2digits: 'EG',
    isoCode3digits: 'EGY',
  },
  {
    name: 'El Salvador',
    code: '503',
    isoCode2digits: 'SV',
    isoCode3digits: 'SLV',
  },
  {
    name: 'Equatorial Guinea',
    code: '240',
    isoCode2digits: 'GQ',
    isoCode3digits: 'GNQ',
  },
  {
    name: 'Eritrea',
    code: '291',
    isoCode2digits: 'ER',
    isoCode3digits: 'ERI',
  },
  {
    name: 'Estonia',
    code: '372',
    isoCode2digits: 'EE',
    isoCode3digits: 'EST',
  },
  {
    name: 'Ethiopia',
    code: '251',
    isoCode2digits: 'ET',
    isoCode3digits: 'ETH',
  },
  {
    name: 'Falkland Islands',
    code: '500',
    isoCode2digits: 'FK',
    isoCode3digits: 'FLK',
  },
  {
    name: 'Faroe Islands',
    code: '298',
    isoCode2digits: 'FO',
    isoCode3digits: 'FRO',
  },
  {
    name: 'Fiji',
    code: '679',
    isoCode2digits: 'FJ',
    isoCode3digits: 'FJI',
  },
  {
    name: 'Finland',
    code: '358',
    isoCode2digits: 'FI',
    isoCode3digits: 'FIN',
  },
  {
    name: 'France',
    code: '33',
    isoCode2digits: 'FR',
    isoCode3digits: 'FRA',
  },
  {
    name: 'French Polynesia',
    code: '689',
    isoCode2digits: 'PF',
    isoCode3digits: 'PYF',
  },
  {
    name: 'Gabon',
    code: '241',
    isoCode2digits: 'GA',
    isoCode3digits: 'GAB',
  },
  {
    name: 'Gambia',
    code: '220',
    isoCode2digits: 'GM',
    isoCode3digits: 'GMB',
  },
  {
    name: 'Georgia',
    code: '995',
    isoCode2digits: 'GE',
    isoCode3digits: 'GEO',
  },
  {
    name: 'Germany',
    code: '49',
    isoCode2digits: 'DE',
    isoCode3digits: 'DEU',
  },
  {
    name: 'Ghana',
    code: '233',
    isoCode2digits: 'GH',
    isoCode3digits: 'GHA',
  },
  {
    name: 'Gibraltar',
    code: '350',
    isoCode2digits: 'GI',
    isoCode3digits: 'GIB',
  },
  {
    name: 'Greece',
    code: '30',
    isoCode2digits: 'GR',
    isoCode3digits: 'GRC',
  },
  {
    name: 'Greenland',
    code: '299',
    isoCode2digits: 'GL',
    isoCode3digits: 'GRL',
  },
  {
    name: 'Grenada',
    code: '1',
    isoCode2digits: 'GD',
    isoCode3digits: 'GRD',
  },
  {
    name: 'Guam',
    code: '1',
    isoCode2digits: 'GU',
    isoCode3digits: 'GUM',
  },
  {
    name: 'Guatemala',
    code: '502',
    isoCode2digits: 'GT',
    isoCode3digits: 'GTM',
  },
  {
    name: 'Guernsey',
    code: '44',
    isoCode2digits: 'GG',
    isoCode3digits: 'GGY',
  },
  {
    name: 'Guinea',
    code: '224',
    isoCode2digits: 'GN',
    isoCode3digits: 'GIN',
  },
  {
    name: 'Guinea-Bissau',
    code: '245',
    isoCode2digits: 'GW',
    isoCode3digits: 'GNB',
  },
  {
    name: 'Guyana',
    code: '592',
    isoCode2digits: 'GY',
    isoCode3digits: 'GUY',
  },
  {
    name: 'Haiti',
    code: '509',
    isoCode2digits: 'HT',
    isoCode3digits: 'HTI',
  },
  {
    name: 'Honduras',
    code: '504',
    isoCode2digits: 'HN',
    isoCode3digits: 'HND',
  },
  {
    name: 'Hong Kong',
    code: '852',
    isoCode2digits: 'HK',
    isoCode3digits: 'HKG',
  },
  {
    name: 'Hungary',
    code: '36',
    isoCode2digits: 'HU',
    isoCode3digits: 'HUN',
  },
  {
    name: 'Iceland',
    code: '354',
    isoCode2digits: 'IS',
    isoCode3digits: 'ISL',
  },
  {
    name: 'India',
    code: '91',
    isoCode2digits: 'IN',
    isoCode3digits: 'IND',
  },
  {
    name: 'Indonesia',
    code: '62',
    isoCode2digits: 'ID',
    isoCode3digits: 'IDN',
  },
  {
    name: 'Iran',
    code: '98',
    isoCode2digits: 'IR',
    isoCode3digits: 'IRN',
  },
  {
    name: 'Iraq',
    code: '964',
    isoCode2digits: 'IQ',
    isoCode3digits: 'IRQ',
  },
  {
    name: 'Ireland',
    code: '353',
    isoCode2digits: 'IE',
    isoCode3digits: 'IRL',
  },
  {
    name: 'Isle of Man',
    code: '44',
    isoCode2digits: 'IM',
    isoCode3digits: 'IMN',
  },
  {
    name: 'Israel',
    code: '972',
    isoCode2digits: 'IL',
    isoCode3digits: 'ISR',
  },
  {
    name: 'Italy',
    code: '39',
    isoCode2digits: 'IT',
    isoCode3digits: 'ITA',
  },
  {
    name: 'Ivory Coast',
    code: '225',
    isoCode2digits: 'CI',
    isoCode3digits: 'CIV',
  },
  {
    name: 'Jamaica',
    code: '1',
    isoCode2digits: 'JM',
    isoCode3digits: 'JAM',
  },
  {
    name: 'Japan',
    code: '81',
    isoCode2digits: 'JP',
    isoCode3digits: 'JPN',
  },
  {
    name: 'Jersey',
    code: '44',
    isoCode2digits: 'JE',
    isoCode3digits: 'JEY',
  },
  {
    name: 'Jordan',
    code: '962',
    isoCode2digits: 'JO',
    isoCode3digits: 'JOR',
  },
  {
    name: 'Kazakhstan',
    code: '7',
    isoCode2digits: 'KZ',
    isoCode3digits: 'KAZ',
  },
  {
    name: 'Kenya',
    code: '254',
    isoCode2digits: 'KE',
    isoCode3digits: 'KEN',
  },
  {
    name: 'Kiribati',
    code: '686',
    isoCode2digits: 'KI',
    isoCode3digits: 'KIR',
  },
  {
    name: 'Kosovo',
    code: '383',
    isoCode2digits: 'XK',
    isoCode3digits: 'XKX',
  },
  {
    name: 'Kuwait',
    code: '965',
    isoCode2digits: 'KW',
    isoCode3digits: 'KWT',
  },
  {
    name: 'Kyrgyzstan',
    code: '996',
    isoCode2digits: 'KG',
    isoCode3digits: 'KGZ',
  },
  {
    name: 'Laos',
    code: '856',
    isoCode2digits: 'LA',
    isoCode3digits: 'LAO',
  },
  {
    name: 'Latvia',
    code: '371',
    isoCode2digits: 'LV',
    isoCode3digits: 'LVA',
  },
  {
    name: 'Lebanon',
    code: '961',
    isoCode2digits: 'LB',
    isoCode3digits: 'LBN',
  },
  {
    name: 'Lesotho',
    code: '266',
    isoCode2digits: 'LS',
    isoCode3digits: 'LSO',
  },
  {
    name: 'Liberia',
    code: '231',
    isoCode2digits: 'LR',
    isoCode3digits: 'LBR',
  },
  {
    name: 'Libya',
    code: '218',
    isoCode2digits: 'LY',
    isoCode3digits: 'LBY',
  },
  {
    name: 'Liechtenstein',
    code: '423',
    isoCode2digits: 'LI',
    isoCode3digits: 'LIE',
  },
  {
    name: 'Lithuania',
    code: '370',
    isoCode2digits: 'LT',
    isoCode3digits: 'LTU',
  },
  {
    name: 'Luxembourg',
    code: '352',
    isoCode2digits: 'LU',
    isoCode3digits: 'LUX',
  },
  {
    name: 'Macau',
    code: '853',
    isoCode2digits: 'MO',
    isoCode3digits: 'MAC',
  },
  {
    name: 'Macedonia',
    code: '389',
    isoCode2digits: 'MK',
    isoCode3digits: 'MKD',
  },
  {
    name: 'Madagascar',
    code: '261',
    isoCode2digits: 'MG',
    isoCode3digits: 'MDG',
  },
  {
    name: 'Malawi',
    code: '265',
    isoCode2digits: 'MW',
    isoCode3digits: 'MWI',
  },
  {
    name: 'Malaysia',
    code: '60',
    isoCode2digits: 'MY',
    isoCode3digits: 'MYS',
  },
  {
    name: 'Maldives',
    code: '960',
    isoCode2digits: 'MV',
    isoCode3digits: 'MDV',
  },
  {
    name: 'Mali',
    code: '223',
    isoCode2digits: 'ML',
    isoCode3digits: 'MLI',
  },
  {
    name: 'Malta',
    code: '356',
    isoCode2digits: 'MT',
    isoCode3digits: 'MLT',
  },
  {
    name: 'Marshall Islands',
    code: '692',
    isoCode2digits: 'MH',
    isoCode3digits: 'MHL',
  },
  {
    name: 'Mauritania',
    code: '222',
    isoCode2digits: 'MR',
    isoCode3digits: 'MRT',
  },
  {
    name: 'Mauritius',
    code: '230',
    isoCode2digits: 'MU',
    isoCode3digits: 'MUS',
  },
  {
    name: 'Mayotte',
    code: '262',
    isoCode2digits: 'YT',
    isoCode3digits: 'MYT',
  },
  {
    name: 'Mexico',
    code: '52',
    isoCode2digits: 'MX',
    isoCode3digits: 'MEX',
  },
  {
    name: 'Micronesia',
    code: '691',
    isoCode2digits: 'FM',
    isoCode3digits: 'FSM',
  },
  {
    name: 'Moldova',
    code: '373',
    isoCode2digits: 'MD',
    isoCode3digits: 'MDA',
  },
  {
    name: 'Monaco',
    code: '377',
    isoCode2digits: 'MC',
    isoCode3digits: 'MCO',
  },
  {
    name: 'Mongolia',
    code: '976',
    isoCode2digits: 'MN',
    isoCode3digits: 'MNG',
  },
  {
    name: 'Montenegro',
    code: '382',
    isoCode2digits: 'ME',
    isoCode3digits: 'MNE',
  },
  {
    name: 'Montserrat',
    code: '1',
    isoCode2digits: 'MS',
    isoCode3digits: 'MSR',
  },
  {
    name: 'Morocco',
    code: '212',
    isoCode2digits: 'MA',
    isoCode3digits: 'MAR',
  },
  {
    name: 'Mozambique',
    code: '258',
    isoCode2digits: 'MZ',
    isoCode3digits: 'MOZ',
  },
  {
    name: 'Namibia',
    code: '264',
    isoCode2digits: 'NA',
    isoCode3digits: 'NAM',
  },
  {
    name: 'Nauru',
    code: '674',
    isoCode2digits: 'NR',
    isoCode3digits: 'NRU',
  },
  {
    name: 'Nepal',
    code: '977',
    isoCode2digits: 'NP',
    isoCode3digits: 'NPL',
  },
  {
    name: 'Netherlands',
    code: '31',
    isoCode2digits: 'NL',
    isoCode3digits: 'NLD',
  },
  {
    name: 'Netherlands Antilles',
    code: '599',
    isoCode2digits: 'AN',
    isoCode3digits: 'ANT',
  },
  {
    name: 'New Caledonia',
    code: '687',
    isoCode2digits: 'NC',
    isoCode3digits: 'NCL',
  },
  {
    name: 'New Zealand',
    code: '64',
    isoCode2digits: 'NZ',
    isoCode3digits: 'NZL',
  },
  {
    name: 'Nicaragua',
    code: '505',
    isoCode2digits: 'NI',
    isoCode3digits: 'NIC',
  },
  {
    name: 'Niger',
    code: '227',
    isoCode2digits: 'NE',
    isoCode3digits: 'NER',
  },
  {
    name: 'Nigeria',
    code: '234',
    isoCode2digits: 'NG',
    isoCode3digits: 'NGA',
  },
  {
    name: 'Niue',
    code: '683',
    isoCode2digits: 'NU',
    isoCode3digits: 'NIU',
  },
  {
    name: 'Northern Mariana Islands',
    code: '1',
    isoCode2digits: 'MP',
    isoCode3digits: 'MNP',
  },
  {
    name: 'North Korea',
    code: '850',
    isoCode2digits: 'KP',
    isoCode3digits: 'PRK',
  },
  {
    name: 'Norway',
    code: '47',
    isoCode2digits: 'NO',
    isoCode3digits: 'NOR',
  },
  {
    name: 'Oman',
    code: '968',
    isoCode2digits: 'OM',
    isoCode3digits: 'OMN',
  },
  {
    name: 'Pakistan',
    code: '92',
    isoCode2digits: 'PK',
    isoCode3digits: 'PAK',
  },
  {
    name: 'Palau',
    code: '680',
    isoCode2digits: 'PW',
    isoCode3digits: 'PLW',
  },
  {
    name: 'Palestine',
    code: '970',
    isoCode2digits: 'PS',
    isoCode3digits: 'PSE',
  },
  {
    name: 'Panama',
    code: '507',
    isoCode2digits: 'PA',
    isoCode3digits: 'PAN',
  },
  {
    name: 'Papua New Guinea',
    code: '675',
    isoCode2digits: 'PG',
    isoCode3digits: 'PNG',
  },
  {
    name: 'Paraguay',
    code: '595',
    isoCode2digits: 'PY',
    isoCode3digits: 'PRY',
  },
  {
    name: 'Peru',
    code: '51',
    isoCode2digits: 'PE',
    isoCode3digits: 'PER',
  },
  {
    name: 'Philippines',
    code: '63',
    isoCode2digits: 'PH',
    isoCode3digits: 'PHL',
  },
  {
    name: 'Pitcairn',
    code: '64',
    isoCode2digits: 'PN',
    isoCode3digits: 'PCN',
  },
  {
    name: 'Poland',
    code: '48',
    isoCode2digits: 'PL',
    isoCode3digits: 'POL',
  },
  {
    name: 'Portugal',
    code: '351',
    isoCode2digits: 'PT',
    isoCode3digits: 'PRT',
  },
  {
    name: 'Puerto Rico',
    code: '1',
    isoCode2digits: 'PR',
    isoCode3digits: 'PRI',
  },
  {
    name: 'Qatar',
    code: '974',
    isoCode2digits: 'QA',
    isoCode3digits: 'QAT',
  },
  {
    name: 'Reunion',
    code: '262',
    isoCode2digits: 'RE',
    isoCode3digits: 'REU',
  },
  {
    name: 'Romania',
    code: '40',
    isoCode2digits: 'RO',
    isoCode3digits: 'ROU',
  },
  {
    name: 'Russia',
    code: '7',
    isoCode2digits: 'RU',
    isoCode3digits: 'RUS',
  },
  {
    name: 'Rwanda',
    code: '250',
    isoCode2digits: 'RW',
    isoCode3digits: 'RWA',
  },
  {
    name: 'Saint Barthelemy',
    code: '590',
    isoCode2digits: 'BL',
    isoCode3digits: 'BLM',
  },
  {
    name: 'Samoa',
    code: '685',
    isoCode2digits: 'WS',
    isoCode3digits: 'WSM',
  },
  {
    name: 'San Marino',
    code: '378',
    isoCode2digits: 'SM',
    isoCode3digits: 'SMR',
  },
  {
    name: 'Sao Tome and Principe',
    code: '239',
    isoCode2digits: 'ST',
    isoCode3digits: 'STP',
  },
  {
    name: 'Saudi Arabia',
    code: '966',
    isoCode2digits: 'SA',
    isoCode3digits: 'SAU',
  },
  {
    name: 'Senegal',
    code: '221',
    isoCode2digits: 'SN',
    isoCode3digits: 'SEN',
  },
  {
    name: 'Serbia',
    code: '381',
    isoCode2digits: 'RS',
    isoCode3digits: 'SRB',
  },
  {
    name: 'Seychelles',
    code: '248',
    isoCode2digits: 'SC',
    isoCode3digits: 'SYC',
  },
  {
    name: 'Sierra Leone',
    code: '232',
    isoCode2digits: 'SL',
    isoCode3digits: 'SLE',
  },
  {
    name: 'Singapore',
    code: '65',
    isoCode2digits: 'SG',
    isoCode3digits: 'SGP',
  },
  {
    name: 'Sint Maarten',
    code: '1',
    isoCode2digits: 'SX',
    isoCode3digits: 'SXM',
  },
  {
    name: 'Slovakia',
    code: '421',
    isoCode2digits: 'SK',
    isoCode3digits: 'SVK',
  },
  {
    name: 'Slovenia',
    code: '386',
    isoCode2digits: 'SI',
    isoCode3digits: 'SVN',
  },
  {
    name: 'Solomon Islands',
    code: '677',
    isoCode2digits: 'SB',
    isoCode3digits: 'SLB',
  },
  {
    name: 'Somalia',
    code: '252',
    isoCode2digits: 'SO',
    isoCode3digits: 'SOM',
  },
  {
    name: 'South Africa',
    code: '27',
    isoCode2digits: 'ZA',
    isoCode3digits: 'ZAF',
  },
  {
    name: 'South Korea',
    code: '82',
    isoCode2digits: 'KR',
    isoCode3digits: 'KOR',
  },
  {
    name: 'South Sudan',
    code: '211',
    isoCode2digits: 'SS',
    isoCode3digits: 'SSD',
  },
  {
    name: 'Spain',
    code: '34',
    isoCode2digits: 'ES',
    isoCode3digits: 'ESP',
  },
  {
    name: 'Sri Lanka',
    code: '94',
    isoCode2digits: 'LK',
    isoCode3digits: 'LKA',
  },
  {
    name: 'Saint Helena',
    code: '290',
    isoCode2digits: 'SH',
    isoCode3digits: 'SHN',
  },
  {
    name: 'Saint Kitts and Nevis',
    code: '1',
    isoCode2digits: 'KN',
    isoCode3digits: 'KNA',
  },
  {
    name: 'Saint Lucia',
    code: '1',
    isoCode2digits: 'LC',
    isoCode3digits: 'LCA',
  },
  {
    name: 'Saint Martin',
    code: '590',
    isoCode2digits: 'MF',
    isoCode3digits: 'MAF',
  },
  {
    name: 'Saint Pierre and Miquelon',
    code: '508',
    isoCode2digits: 'PM',
    isoCode3digits: 'SPM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: '1',
    isoCode2digits: 'VC',
    isoCode3digits: 'VCT',
  },
  {
    name: 'Sudan',
    code: '249',
    isoCode2digits: 'SD',
    isoCode3digits: 'SDN',
  },
  {
    name: 'Suriname',
    code: '597',
    isoCode2digits: 'SR',
    isoCode3digits: 'SUR',
  },
  {
    name: 'Svalbard and Jan Mayen',
    code: '47',
    isoCode2digits: 'SJ',
    isoCode3digits: 'SJM',
  },
  {
    name: 'Swaziland',
    code: '268',
    isoCode2digits: 'SZ',
    isoCode3digits: 'SWZ',
  },
  {
    name: 'Sweden',
    code: '46',
    isoCode2digits: 'SE',
    isoCode3digits: 'SWE',
  },
  {
    name: 'Switzerland',
    code: '41',
    isoCode2digits: 'CH',
    isoCode3digits: 'CHE',
  },
  {
    name: 'Syria',
    code: '963',
    isoCode2digits: 'SY',
    isoCode3digits: 'SYR',
  },
  {
    name: 'Taiwan',
    code: '886',
    isoCode2digits: 'TW',
    isoCode3digits: 'TWN',
  },
  {
    name: 'Tajikistan',
    code: '992',
    isoCode2digits: 'TJ',
    isoCode3digits: 'TJK',
  },
  {
    name: 'Tanzania',
    code: '255',
    isoCode2digits: 'TZ',
    isoCode3digits: 'TZA',
  },
  {
    name: 'Thailand',
    code: '66',
    isoCode2digits: 'TH',
    isoCode3digits: 'THA',
  },
  {
    name: 'Togo',
    code: '228',
    isoCode2digits: 'TG',
    isoCode3digits: 'TGO',
  },
  {
    name: 'Tokelau',
    code: '690',
    isoCode2digits: 'TK',
    isoCode3digits: 'TKL',
  },
  {
    name: 'Tonga',
    code: '676',
    isoCode2digits: 'TO',
    isoCode3digits: 'TON',
  },
  {
    name: 'Trinidad and Tobago',
    code: '1',
    isoCode2digits: 'TT',
    isoCode3digits: 'TTO',
  },
  {
    name: 'Tunisia',
    code: '216',
    isoCode2digits: 'TN',
    isoCode3digits: 'TUN',
  },
  {
    name: 'Turkey',
    code: '90',
    isoCode2digits: 'TR',
    isoCode3digits: 'TUR',
  },
  {
    name: 'Turkmenistan',
    code: '993',
    isoCode2digits: 'TM',
    isoCode3digits: 'TKM',
  },
  {
    name: 'Turks and Caicos Islands',
    code: '1',
    isoCode2digits: 'TC',
    isoCode3digits: 'TCA',
  },
  {
    name: 'Tuvalu',
    code: '688',
    isoCode2digits: 'TV',
    isoCode3digits: 'TUV',
  },
  {
    name: 'United Arab Emirates',
    code: '971',
    isoCode2digits: 'AE',
    isoCode3digits: 'ARE',
  },
  {
    name: 'Uganda',
    code: '256',
    isoCode2digits: 'UG',
    isoCode3digits: 'UGA',
  },
  {
    name: 'United Kingdom',
    code: '44',
    isoCode2digits: 'GB',
    isoCode3digits: 'GBR',
  },
  {
    name: 'Ukraine',
    code: '380',
    isoCode2digits: 'UA',
    isoCode3digits: 'UKR',
  },
  {
    name: 'Uruguay',
    code: '598',
    isoCode2digits: 'UY',
    isoCode3digits: 'URY',
  },
  {
    name: 'United States',
    code: '1',
    isoCode2digits: 'US',
    isoCode3digits: 'USA',
  },
  {
    name: 'Uzbekistan',
    code: '998',
    isoCode2digits: 'UZ',
    isoCode3digits: 'UZB',
  },
  {
    name: 'Vanuatu',
    code: '678',
    isoCode2digits: 'VU',
    isoCode3digits: 'VUT',
  },
  {
    name: 'Vatican',
    code: '379',
    isoCode2digits: 'VA',
    isoCode3digits: 'VAT',
  },
  {
    name: 'Venezuela',
    code: '58',
    isoCode2digits: 'VE',
    isoCode3digits: 'VEN',
  },
  {
    name: 'Vietnam',
    code: '84',
    isoCode2digits: 'VN',
    isoCode3digits: 'VNM',
  },
  {
    name: 'U.S. Virgin Islands',
    code: '1',
    isoCode2digits: 'VI',
    isoCode3digits: 'VIR',
  },
  {
    name: 'Wallis and Futuna',
    code: '681',
    isoCode2digits: 'WF',
    isoCode3digits: 'WLF',
  },
  {
    name: 'Western Sahara',
    code: '212',
    isoCode2digits: 'EH',
    isoCode3digits: 'ESH',
  },
  {
    name: 'Yemen',
    code: '967',
    isoCode2digits: 'YE',
    isoCode3digits: 'YEM',
  },
  {
    name: 'Zambia',
    code: '260',
    isoCode2digits: 'ZM',
    isoCode3digits: 'ZMB',
  },
  {
    name: 'Zimbabwe',
    code: '263',
    isoCode2digits: 'ZW',
    isoCode3digits: 'ZWE',
  },
];

export default dialCodes;
